import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { get } from '../../../api/fetch';
import { ROUTE } from '../utils/routes';
import { cartSessionStorageKey, getSessionStorageJSON, proposalsCountStorageKey } from '../utils/utils';
import { useIsLoggedIn } from './useIsLoggedIn';
import { useUserEligibility } from './useUserEligibility';
import { Count } from '../types/Count';

export const useBasketCount = (): UseQueryResult<number, Error> => {
  const { data: isLoggedIn } = useIsLoggedIn();
  const { data: eligibility } = useUserEligibility();

  const sessionValue = getSessionStorageJSON<Count>(proposalsCountStorageKey)?.count;

  const enabled = !!isLoggedIn && !!eligibility?.iditEligible;

  return useQuery({
    queryKey: [cartSessionStorageKey],
    queryFn: async () => {
      const response = await get<Count>('/api-sands-navigation/proposals/count');

      document.dispatchEvent(
        new CustomEvent('nav-cart', {
          detail: {
            url: ROUTE.KURV,
            items: response.count ?? 0
          }
        })
      );

      if (response?.count !== undefined) {
        sessionStorage.setItem(proposalsCountStorageKey, JSON.stringify(response));
      }

      return response.count;
    },
    select: (result: number) => result ?? 0,
    initialData: sessionValue ?? 0,
    enabled
  });
};
